export { Robot } from './Robot'
export { RobotData } from './data/RobotData'

import { Plugin } from '@leafer-ui/draw'

Plugin.add('robot')